import { getStatsOverview } from "routes/sfg20-admin/plugins/system-info/current-usage-tab/controller/get-stats-overview"
import { Box, CircularProgress, Grid2, Tab, Tabs, Typography } from "@mui/material"
import { StatsOverviewItem } from "routes/sfg20-admin/plugins/system-info/current-usage-tab/stats-overview-item"
import { useState } from "react"
import { DownloadButton } from "routes/sfg20-admin/plugins/system-info/common/components/download-button"

export function StatsOverview() {
    const data = getStatsOverview.useResults()

    const stats = data?.results

    const [currentTab, setCurrentTab] = useState(0)

    function handleChange(event, newValue) {
        setCurrentTab(newValue)
    }

    if (!stats)
        return (
            <Box>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <CircularProgress />
                </Box>
                <Typography mt={4} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                    Fetching Data
                </Typography>
            </Box>
        )
    return (
        <>
            <Tabs variant="scrollable" scrollButtons={false} onChange={handleChange} value={currentTab}>
                <Tab label="Regimes & Schedules"></Tab>
                <Tab label="System Usage" />
                <Tab label="Licence Utilisation" />
                <Tab label="Sharing & Data" />
            </Tabs>
            {currentTab === 0 && <StatsGroup stats={stats} group="Regimes & Schedules" />}
            {currentTab === 1 && <StatsGroup stats={stats} group="System Usage" />}
            {currentTab === 2 && <StatsGroup stats={stats} group="Licence Utilisation" />}
            {currentTab === 3 && <StatsGroup stats={stats} group="Sharing & Data" />}

            <DownloadButton
                data={{ value: stats }}
                title="All Current Usage"
                columns={[
                    { title: "Statistic", value: "statistic" },
                    { title: "Value", value: "value" },
                ]}
            />
        </>
    )
}

export function StatsGroup({ group, stats }) {
    return (
        <Grid2 container spacing={3} justifyContent="flex-start" alignItems="stretch" mt={4}>
            {stats
                .filter((item) => item.group === group)
                .map((item, i) => {
                    if (!item) {
                        return null
                    }
                    return <StatsOverviewItem item={item} key={`item_${i}`} />
                })}
        </Grid2>
    )
}
